const STATUS = {
    INVITED: 'INVITED',
    ACCEPTED: 'ACCEPTED',
    STARTED: 'STARTED',
    PAUSED: 'PAUSED',
    CANCELLED: 'CANCELLED',
    COMPLETED: 'COMPLETED'
}

const MODE = {
    DEFAULT: 'DEFAULT',
    ADD_MORE: 'ADD_MORE',
    PAUSE_CANCEL: 'PAUSE_CANCEL',
    PAUSE: 'PAUSE',
    CANCEL: 'CANCEL',
    RESUME: 'RESUME',
    STARTED: 'STARTED'
}

export {
    STATUS,
    MODE
}
